export const SUCCESS = 'success';
export const WARN = 'warn';
export const INFO = 'info';
export const LOADING = 'loading';
export const ERROR = 'error';
